import React from 'react';
import { StarProps } from './types';
import { variantToStar } from './constants';

const RatingStar = ({ starVariant = 'empty' }: StarProps) => {
  const Star = variantToStar[starVariant];

  return <Star color="grey_1200" />;
};

RatingStar.displayName = 'RatingStar';
export default RatingStar;
